import React, { Component } from 'react'
import { useSelector, useDispatch, connect } from 'react-redux'
import Carousel from 'react-bootstrap/Carousel';

import {
  CInputGroupText,
  CInputGroupAppend,
  CBadge,
  CCard,
  CCardBody,
  CCardHeader,
  CCol,
  CDataTable,
  CRow,
  CFormGroup,
  CInputGroup,
  CInput,
  CButton,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CTooltip,
  CPopover,
  CLabel,
  CSelect,
  CFormText,
  CTextarea,
  CInputFile,
  CSwitch,
} from '@coreui/react'
import { createHashHistory } from 'history'
import HeaderSection from "../header/HeaderSection"
import FooterSection from '../Footer/FooterSection'
import { Link } from 'react-router-dom'
import Adminsidebar from './AdminSidebar';
import AdminHeader from './AdminHeader';
const history = createHashHistory()
const FormMask = (props) => {
  return (
    <>
  {/* Mirrored from dreamguys.co.in/demo/doccure/admin/form-mask.html by HTTrack Website Copier/3.x [XR&CO'2014], Sat, 30 Nov 2019 04:12:55 GMT */}
  <meta charSet="utf-8" />
  <meta
    name="viewport"
    content="width=device-width, initial-scale=1.0, user-scalable=0"
  />
  <title>Doccure - Form Mask</title>
  {/* Favicon */}
  <link rel="shortcut icon" type="image/x-icon" href="assets/img/favicon.png" />
  {/* Bootstrap CSS */}
  <link rel="stylesheet" href="assets/css/bootstrap.min.css" />
  {/* Fontawesome CSS */}
  <link rel="stylesheet" href="assets/css/font-awesome.min.css" />
  {/* Feathericon CSS */}
  <link rel="stylesheet" href="assets/css/feathericon.min.css" />
  {/* Main CSS */}
  <link rel="stylesheet" href="assets/css/style.css" />
  {/*[if lt IE 9]>
			
			
		<![endif]*/}
 

    
    {/* Page Wrapper */}
    <div className="page-wrapper pt-1">
      <div className="content container-fluid">
        {/* Page Header */}
        <div className="page-header">
          <div className="row">
            <div className="col-sm-12">
              <h3 className="page-title">Form Mask</h3>
              <ul className="breadcrumb">
                <li className="breadcrumb-item">
                  <li className="breadcrumb-item"><Link to="/admin">Dashboard</Link></li>
                </li>
                <li className="breadcrumb-item active">Form Mask</li>
              </ul>
            </div>
          </div>
        </div>
        {/* /Page Header */}
        <div className="row">
          <div className="col-sm-12">
            <div className="card">
              <div className="card-header">
                <h5 className="card-title">Form Mask</h5>
                <p className="card-text">
                  Input masks can be used to force the user to enter data
                  conform a specific format. Unlike validation, the user can't
                  enter any other key than the ones specified by the mask.
                </p>
              </div>
              <div className="card-body">
                <form action="#">
                  <div className="form-group">
                    <label>Phone</label>
                    <input type="text" id="phone" className="form-control" />
                    <span className="form-text text-muted">(999) 999-9999</span>
                  </div>
                  <div className="form-group">
                    <label>Date</label>
                    <input type="text" id="date" className="form-control" />
                    <span className="form-text text-muted">dd/mm/yyyy</span>
                  </div>
                  <div className="form-group">
                    <label>SSN field 1</label>
                    <input type="text" id="ssn" className="form-control" />
                    <span className="form-text text-muted">
                      e.g "999-99-9999"
                    </span>
                  </div>
                  <div className="form-group">
                    <label>Phone field + ext.</label>
                    <input type="text" id="phoneExt" className="form-control" />
                    <span className="form-text text-muted">
                      +40 999 999 999
                    </span>
                  </div>
                  <div className="form-group">
                    <label>Product Key</label>
                    <input type="text" id="product" className="form-control" />
                    <span className="form-text text-muted">
                      e.g a*-999-a999
                    </span>
                  </div>
                  <div className="form-group">
                    <label>Currency</label>
                    <input type="text" id="currency" className="form-control" />
                    <span className="form-text text-muted">
                      $ 999,999,999.99
                    </span>
                  </div>
                  <div className="form-group">
                    <label>Eye Script</label>
                    <input
                      type="text"
                      id="eyescript"
                      className="form-control"
                    />
                    <span className="form-text text-muted">
                      ~9.99 ~9.99 999
                    </span>
                  </div>
                  <div className="form-group">
                    <label>Percent</label>
                    <input type="text" id="pct" className="form-control" />
                    <span className="form-text text-muted">e.g "99%"</span>
                  </div>
                  <div className="form-group mb-0">
                    <label>Credit Card Number</label>
                    <input type="text" className="form-control" id="ccn" />
                    <span className="form-text text-muted">
                      e.g "999.999.999.9999"
                    </span>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    {/* /Page Wrapper */}
 </>

  );
}

// export default TheHeaderDropdown
const mapStateToProps = (state) => ({
})
export default connect(mapStateToProps, {
})(FormMask)
